import { render, staticRenderFns } from "./LogResource.vue?vue&type=template&id=5d9c7ee6&scoped=true"
import script from "./LogResource.vue?vue&type=script&lang=js"
export * from "./LogResource.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9c7ee6",
  null
  
)

export default component.exports